import {
	Alert,
	Box,
	Button,
	Divider,
	Grid,
	Typography,
} from '@barracuda-internal/bds-core-v2';
import React, { ReactElement, useState } from 'react';
import FEATURES from 'src/featureMap';
import withAnalytics from 'src/lib/withAnalytics';
import { ServiceSelectionGrid } from 'src/routes/onboarding/ServiceSelectionGrid';
import { OnboardingStepProps } from 'src/routes/onboarding/types';
import { useApiRequest } from 'src/hooks/useApi';
import { useAppToolchain } from 'src/hooks/useAppToolchain';
import useAuth from 'src/hooks/useAuth';

interface Props extends OnboardingStepProps {
	setStep: (step: number) => void;
}

function ServicesSetup({ setStep, activeStep }: Props): ReactElement {
	const [doCompleteOnboarding, setDoCompleteOnboarding] = useState(0);
	const [connectCount, setConnectCount] = useState(0);
	const { auth } = useAuth();
	const { api } = useAppToolchain();

	useApiRequest(
		() => {
			if (!auth) return;
			if (doCompleteOnboarding > 0 && connectCount != 0) {
				return api.saveAccountConfig(auth.accountDetails.account.id, [
					{
						path: '/onboardedTime',
						op: 'replace',
						value: new Date().toISOString(),
					},
				]);
			}
		},
		[doCompleteOnboarding],
		() => {
			if (doCompleteOnboarding > 0 && connectCount != 0) {
				localStorage.removeItem('is_setup');
				window.location.href = '/detections';
				localStorage.removeItem('malwareScanConsent');
			}
		},
	);

	const handleNext = withAnalytics(FEATURES.onboardingCompleted, () =>
		setDoCompleteOnboarding(doCompleteOnboarding + 1),
	);
	return (
		<>
			<Typography
				variant="h1"
				color="textPrimary"
				gutterBottom
				sx={{marginTop: '32px'}}
			>
				Connect Your Services
			</Typography>
			{connectCount == 0 && doCompleteOnboarding != 0 ? (
				<Alert severity="error">
					<Typography
						variant="body2"
						color="error"
					>
						Data Inspector requires at least one service to be
						connected. Please select from the Connected Services
						options before completing the setup process.
					</Typography>
				</Alert>
			) : null}
			<Divider sx={{ marginTop: '16px' }} />
			<ServiceSelectionGrid
				connectcount={(count) => setConnectCount(count)}
			/>
			<Box sx={{ marginTop: '24px' }}>
				<Grid container direction="row" spacing={1}>
					<Grid item xs={9}></Grid>
					<Grid item xs={1}>
						<Button
							onClick={() => setStep(activeStep - 1)}
							bdsType="interactiveSubtle"
						>
							Back
						</Button>
					</Grid>
					<Grid item xs={2}>
						<Button onClick={handleNext}>
							Complete
						</Button>
					</Grid>
				</Grid>
			</Box>
		</>
	);
}

export default ServicesSetup;
